const doc = [({"en":({"adminConstantHotelFilterType":({"meal":"Meal", "planOption":"Plan option", "roomAmenity":"Room amenity", "roomProperty":"Room property"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;